import React, { Component } from "react";

import EmojiStronglyDisagree from "../../../containers/assets/bars-emoji-strongly-disagree.svg";
import EmojiNeutral from "../../../containers/assets/bars-emoji-neutral.svg";
import EmojiStronglyAgree from "../../../containers/assets/bars-emoji-strongly-agree.svg";

const rating = Array.from({ length: 5 }, (_, i) => i + 1);

class Bars extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.values
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, values } = this.props;

    if (prevProps.id !== id) {
      this.setState(() => ({ selectedValues: values }));
    }
  }

  handleSingleSelect = value => {
    const { selectedValues } = this.state;
    const { feedback, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    if (selectedValues !== value) {
      this.setState(
        () => ({ selectedValues: value }),
        () => {
          const { onChange, id } = this.props;

          const hasError = !rating.includes(value);

          if (onChange)
            onChange({
              id,
              value,
              type: 'bars',
              hasError,
              feedback,
            });
        }
      );
    }
  };

  handleMultiSelect = (teammate, value) => {
    const { selectedValues } = this.state;
    const { feedbacks, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return;
    }

    const newValues = [...selectedValues];
    let answerIndex = newValues.findIndex(i => i.feedback === feedback.id);
    let stateChanged = false;
    if (answerIndex === -1) {
      newValues.push({
        feedback: feedback.id,
        value: value,
      });
      stateChanged = true;
    } else if (answerIndex >= 0 && newValues[answerIndex].value !== value) {
      newValues[answerIndex].value = value;
      stateChanged = true;
    }

    if (stateChanged) {
      this.setState({
        selectedValues: newValues,
      }, () => {
        const { onChange, id } = this.props;

        if (onChange) {
          onChange({
            id,
            value: value,
            type: "bars",
            hasError: false,
            feedback: feedback.id,
          });
        }
      });
    }
  };

  isMultiRatingSelected = (teammate, value) => {
    const { selectedValues } = this.state;
    const { feedbacks } = this.props;

    const feedback = feedbacks[teammate.id];
    if (!feedback) {
      return false;
    }

    const answer = selectedValues.find(i => i.feedback === feedback.id);
    if (!answer) {
      return false;
    }

    return answer.value === value;
  }

  render() {
    const {
      title,
      options,
      teamList,
      category,
      readonlyMode
    } = this.props;
    const { selectedValues } = this.state;

    const rateTitle = category === 'self_assessment'
      ? 'Rate your behavior'
      : 'Rate your teammate’s behavior'

    return (
      <div className="bars-question-block">
        <div className="title">{title}</div>
        <div className="bars-wrapper">
          <div className="bars-left-part">
            {
              options.map((item, index) => {
                let text = item.text;
                text = text.replace(/[^\r\n]+/g, '<li>$&</li>');
                return (
                  <div className="bar-option" key={index}>
                    <div className="bar-header">
                      <span>{item.list_order}</span>
                      <span>
                        {
                          item.list_order === 1 &&
                          <img
                            alt="Strongly Disagree"
                            src={EmojiStronglyDisagree}
                          />
                        }
                        {
                          item.list_order === 3 &&
                          <img
                            alt="Neutral"
                            src={EmojiNeutral}
                          />
                        }
                        {
                          item.list_order === 5 &&
                          <img
                            alt="Strongly Agree"
                            src={EmojiStronglyAgree}
                          />
                        }
                      </span>
                    </div>
                    <div className="bar-content" dangerouslySetInnerHTML={{ __html: text }} />
                  </div>
                )
              })
            }
          </div>
          <div className="bars-right-part">
            <h4>{rateTitle}</h4>
            <h5>* A rating of 3 or higher = 100%</h5>
            <div className="bars-teammates">
              {
                category === 'self_assessment' &&
                <div className="bar-teammate">
                  <div className="bar-teammate-rating">
                    {rating.map((ratingItem) => {
                      let itemClass = ratingItem === selectedValues ? 'selected' : '';
                      itemClass += readonlyMode ? ' inactive' : '';
                      return (
                        <span
                          key={ratingItem}
                          onClick={() => this.handleSingleSelect(ratingItem)}
                          className={itemClass}
                        >
                          {ratingItem}
                        </span>
                      )
                    })}
                  </div>
                </div>
              }
              {
                category === 'collaboration' &&
                <div>
                  {
                    teamList.map((teammateItem, teammateIndex) => (
                      <div key={teammateIndex} className="bar-teammate">
                        <div className="bar-teammate-name">{teammateItem.fullname}</div>
                        <div className="bar-teammate-rating">
                          {rating.map((ratingItem) => {
                            let itemClass = this.isMultiRatingSelected(teammateItem, ratingItem) ? 'selected' : '';
                            itemClass += readonlyMode ? ' inactive' : '';
                            return (
                              <span
                                key={ratingItem}
                                onClick={() => this.handleMultiSelect(teammateItem, ratingItem)}
                                className={itemClass}
                              >
                                {ratingItem}
                              </span>
                            )
                          })}
                        </div>
                      </div>
                    ))
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Bars;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/bars/index.js